module.exports = __webpack_public_path__ + "img/back.34a48692.png";